import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { AngularFireDatabase } from '../../../node_modules/angularfire2/database';
import { CoinsProvider } from './../coins/coins';
import { UserProvider } from '../user/user';
import { ThenableReference } from '../../../node_modules/@firebase/database-types';

import { AddReportComponent } from '../../components/add-report/add-report';
import { Observable } from 'rxjs/Observable';
import "rxjs/add/operator/catch"
import { combineLatest } from 'rxjs/observable/combineLatest';
import { Report } from '../../models/Report';

@Injectable()
export class ReportsProvider {

    allReports: Observable<Report[]>;
    allReportsStocks: Observable<Report[]>;

    constructor(
        private db: AngularFireDatabase,
        private user: UserProvider,
        private modalCtrl: ModalController
    ) {
        this.allReports = this.getallReportsObservable(false).shareReplay(1);
        this.allReportsStocks = this.getallReportsObservable(true).shareReplay(1);
    }

    private getallReportsObservable(stocks = false): Observable<Report[]> {
        let path = `reports`;
        if(stocks) path = 'reports-stocks';

        return combineLatest(this.user.hasAccess(), this.user.isAdmin()).switchMap(access => {
            let hasAccess = access[0];
            let isAdmin = access[1];
            if (!(hasAccess || isAdmin)) return Observable.of([]);
            return this.db.list<Report>(path, ref => ref.orderByChild('timestamp'))
                .snapshotChanges()
                .map(snapshot => {
                    let reports = [];
                    for (let snap of snapshot) {
                        const report: Report = snap.payload.val();
                        report.key = snap.key;
                        reports.push(report)
                        // console.log(liveSignal.key);
                    }
                    return reports.reverse();
                }).catch((error, caught) => {
                    console.log(error);
                    return Observable.of([]);
                })
        })
    }

    public getAllReports(stocks = false): Observable<Report[]> {
        if(stocks) return this.allReportsStocks;
        return this.allReports;
    }

    public addReport(report: Report): ThenableReference {
        let path = 'reports';
        if(report.isStock) path = 'reports-stocks';

        return this.db.database.ref(path).push(report);
    }

    public editReport(report: Report): Promise<void> {
        if (!report.key) return;
        let path = `reports/${report.key}`;
        if(report.isStock) path = `reports-stocks/${report.key}`;

        return this.db.database.ref(path).update(report);
    }

    public removeReport(report: Report): Promise<void> {
        if (!report.key) return;
        let path = `reports/${report.key}`
        if(report.isStock) path = `reports-stocks/${report.key}`
        return this.db.database.ref(path).remove();
    }

    public openReport(report: Report) {
        let modal = this.modalCtrl.create(AddReportComponent, { report: report });
        modal.present();
    }

    public getReportById(id: string, isStock: boolean): Promise<Report> {
        let observable = isStock ? this.allReportsStocks : this.allReports;
        return observable.toPromise()
            .then(reports => {
                for (let report of reports) {
                    if (report.key == id) return report;
                }
                return null;
            })
            .catch(error => { return null });
    }
}



// WEBPACK FOOTER //
// ./src/providers/reports/reports.ts